import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {deserialize, serialize} from '@tisa-group/cdk/json-api';
import {UmpireClub} from '@tisa-group/models';
import {
  CrudService,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
} from '@tisa-group/cdk';

@Injectable()
export class ClubService implements CrudService {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireClub[]>> {
    return this.http
      .get('/clubs', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireClub>> {
    return this.http
      .get(`/clubs/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/clubs/${id}`);
  }

  create(
    body: Partial<UmpireClub>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireClub>> {
    return this.http
      .post('/clubs', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireClub>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireClub>> {
    return this.http
      .patch<JsonApiResponse<UmpireClub>>(`/clubs/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
